import { render, staticRenderFns } from "./External.vue?vue&type=template&id=ca9b2f70&scoped=true&"
import script from "./External.vue?vue&type=script&lang=js&"
export * from "./External.vue?vue&type=script&lang=js&"
import style0 from "./External.vue?vue&type=style&index=0&id=ca9b2f70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9b2f70",
  null
  
)

export default component.exports